/**
 * Utilidades para ficha de producto en catálogo mayorista.
 */

export function distributorTypeLabel(type) {
  return (
    {
      fem: 'Feminizada',
      feminized: 'Feminizada',
      auto: 'Autofloreciente',
      autoflower: 'Autofloreciente',
      regular: 'Regular',
      merch: 'Merchandising',
    }[type] || type || '—'
  )
}

export function getProductImages(product) {
  if (!product) return []
  return (product.images?.length ? product.images : [product.image, product.image_2, product.image_3]).filter(Boolean)
}

export function getPublicProductUrl(product) {
  if (!product?.id) return null
  if (product.show_on_public_web === false) return null
  if (typeof window === 'undefined') return `/producto/${product.id}`
  return `${window.location.origin}/producto/${product.id}`
}

export function stripHtml(html) {
  if (!html || typeof html !== 'string') return ''
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return (tmp.textContent || tmp.innerText || '').trim()
}

export function getProductSpecRows(product) {
  if (!product) return []
  const rows = []
  const push = (label, value) => {
    const v = value != null ? String(value).trim() : ''
    if (v) rows.push({ label, value: v })
  }
  push('Genotipo', product.genotype)
  push('THC', product.thc)
  push('CBD', product.cbd)
  push('Indica', product.indica)
  push('Sativa', product.sativa)
  push('Floración', product.flowering_time)
  push('Ciclo', product.completed_cicle)
  push('Rend. interior', product.yield_indoor)
  push('Rend. exterior', product.yield_outdoor)
  push('Altura int.', product.height_indoor)
  push('Altura ext.', product.height_outdoor)
  push('Aromas', product.flavors)
  push('Efectos', product.effects)
  push('Talle', product.product_size)
  return rows
}

export function productHasRichContent(product) {
  if (!product) return false
  if (stripHtml(product.description)) return true
  if (getProductSpecRows(product).length > 0) return true
  if (product.limited_edition || product.highlighted) return true
  return false
}

export function sortedBlisters(product) {
  return [...(product?.blisters || [])].sort(
    (a, b) => Number(a.seed_count) - Number(b.seed_count)
  )
}

/** Clave única para cantidades en carrito (catálogo mayorista / ingreso). */
export function distributorLineKey(product, blister) {
  if (!blister) return ''
  return String(blister.catalogItemId ?? `${product?.id}-${blister.id}`)
}
